import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { AccordionComponent } from '../../shared/components/accordion/accordion.component';
import { TranslatePipe } from '../../shared/pipes/translate.pipe';

/**
 * Formly wrapper that wraps fields in a collapsible accordion section.
 *
 * Usage in FormlyFieldConfig:
 * ```typescript
 * {
 *   wrappers: ['collapsible-section'],
 *   props: {
 *     collapsibleHeader: 'formBuilder.advancedProperties', // Translation key
 *     collapsibleIsOpen: false, // Default collapsed state
 *   },
 *   fieldGroup: [
 *     // Fields that go in the collapsible section
 *   ]
 * }
 * ```
 *
 * The wrapper:
 * - Wraps field content in an AccordionComponent
 * - Uses props.collapsibleHeader for the accordion header text (supports translation keys)
 * - Uses props.collapsibleIsOpen (default: false) for initial open/closed state
 */
@Component({
  selector: 'app-collapsible-section-wrapper',
  standalone: true,
  imports: [AccordionComponent, TranslatePipe],
  template: `
    <app-accordion
      [headerText]="props['collapsibleHeader'] || 'Show More' | translate"
      [isOpen]="props['collapsibleIsOpen'] !== false"
      [headerTestId]="props['collapsibleTestId'] || null"
    >
      <!-- Formly renders the wrapped field here -->
      <ng-container #fieldComponent></ng-container>
    </app-accordion>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: `
    :host {
      display: block;
      margin-top: var(--margin-md);
      flex-basis: 100%;
    }
  `,
})
export class CollapsibleSectionWrapperComponent extends FieldWrapper {}
